import ModalManager from 'react-overlays/lib/ModalManager';

// Create a container for the modal (instead of document.body)
// This is for the purposes of being able to scope CSS
export const modalContainer = createContainer();

function createContainer() {
    let container;
    if (typeof document !== 'undefined' && typeof document.body.append === 'function') {
        container = document.createElement('section');
        container.classList.add('otrl-body', 'otrl-container');
        document.body.append(container);
    }
    return container;
}

export default class ReactOverlayManager extends ModalManager {
    constructor() {
        super();

        // Keep track of the current modal
        this.currentIndex = -1;

        // Methods are not on prototype, so cannot subclass/use super()
        // Need to override/wrap in constructor
        const { add, remove } = this;

        this.add = (...args) => {
            // add modal to container
            add.apply(this, args);

            this.currentIndex++;
        };

        this.remove = (...args) => {
            // remove modal
            remove.apply(this, args);

            this.currentIndex--;

            // Workaround an accessibility issue with multiple dialogs.
            // When `hideSiblingNodes=true` (the default), it will add `[aria-hidden=true]` to any siblings
            // when you open a new modal. This causes a problem when modal1 opens modal2.
            // In this scenario, modal1 becomes `aria-hidden` which is not removed when modal2 closes!
            // This is a bug, and may be fixed in later versions of react-overlays, but this would require
            // upgrading react-bootstrap also.
            //
            // It would be possible to workaround this by setting `hideSiblingNodes=false`, but
            // This has a drawback: since all modals are accessible, it's possible for the user to
            // accidentally find themselves in modal1 when modal2 is still open.
            //
            // Instead, we will keep the default behaviour, but patch it by removing `[aria-hidden]`
            // from the last-added modal whenever you are closing a modal.

            const modals = modalContainer ? modalContainer.children : [];
            const currentModal = modals[this.currentIndex];
            if (currentModal) {
                currentModal.removeAttribute('aria-hidden');
            }
        };
    }
}



// WEBPACK FOOTER //
// ./src/helpers/ReactOverlayManager.js